import { RoleConstant } from "../models/role-constant";

export const ROLE_ID_TO_NAME_MAP: Record<string, string> = {
    [RoleConstant.globalAdminId]: 'globalAdmin',
    [RoleConstant.generalManager]: 'generalManager',
    [RoleConstant.companyAdminId]: 'companyAdmin',
    [RoleConstant.supervisor]: 'supervisor',
    [RoleConstant.directorOperations]: 'directorOperations',
    [RoleConstant.srDirectorOperations]: 'srDirectorOperations',
    [RoleConstant.employeeId]: 'employee',
    [RoleConstant.vendorId]: 'vendor',
    [RoleConstant.accountsPayableManager1]: 'accountsPayableManager1',
    [RoleConstant.accountsPayableManager2]: 'accountsPayableManager2',
    [RoleConstant.accountsPayableCreator]: 'accountsPayableCreator',
    [RoleConstant.auditor1]: 'auditor1',
    [RoleConstant.auditor2]: 'auditor2',
    [RoleConstant.expenseInitiator]: 'expenseInitiator',
    [RoleConstant.vpOperations]: 'vpOperations',
    [RoleConstant.RMmanager]: 'RMmanager',
};
